(function () {
  'use strict';
  var ROOT = '[data-product-scenes-v2]';
  var ICONS = [
    ['refrigerator|fridge|freezer', '🧊'], ['cpap|oxygen|medical', '🫁'],
    ['light|led|lamp|lighting', '💡'], ['router|modem|wi-fi|wifi', '📶'],
    ['phone|charger|tablet', '📱'], ['sump pump|water pump|well pump|pump', '💧'],
    ['television|tv|monitor', '📺'], ['microwave', '🍲'], ['coffee', '☕'],
    ['vacuum', '🧹'], ['washing machine|washer|dryer|laundry', '🧺'],
    ['air conditioner|air conditioning|heat pump|cooling|rv ac', '❄️'],
    ['heater|heating|furnace', '🔥'], ['fan', '🌀'], ['dishwasher', '🍽️'],
    ['laptop|computer|workstation', '💻'], ['camera|security', '📹'],
    ['grill|bbq|barbecue', '♨️'], ['drill|saw|welder|tool|compressor', '🛠️'],
    ['ev charger|electric car|vehicle', '🚙'], ['tent|camping', '⛺']
  ];
  var SCENE_ICONS = ['🏠', '🚐', '🍔', '🛠️', '🌲'];
  function text(v) { return String(v == null ? '' : v); }
  function esc(s) { return text(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;'); }
  function number(v) { var n = parseFloat(v); return isFinite(n) ? n : 0; }
  function field(node, key) {
    var fields = node && node.fields || [];
    for (var i = 0; i < fields.length; i++) if (fields[i].key === key) return fields[i];
    return null;
  }
  function val(node, key) { var f = field(node, key); return f && f.value != null ? text(f.value) : ''; }
  function ref(node, key) { var f = field(node, key); return f && f.reference ? f.reference : null; }
  function icon(name) {
    var n = text(name).toLowerCase();
    for (var i = 0; i < ICONS.length; i++) {
      var keys = ICONS[i][0].split('|');
      for (var j = 0; j < keys.length; j++) if (n.indexOf(keys[j]) !== -1) return ICONS[i][1];
    }
    return '🔌';
  }
  function gql(config, query, variables) {
    var sf = config.storefront;
    var url = 'https://' + config.shop_domain + '/api/' + sf.version + '/graphql.json';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': sf.token },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (r) {
      if (!r.ok) throw new Error('Storefront API returned HTTP ' + r.status);
      return r.json();
    }).then(function (j) {
      if (j.errors && j.errors.length) throw new Error(j.errors.map(function (e) { return e.message; }).join('; '));
      return j.data;
    });
  }
  var DEVICE_QUERY = 'query GetDevices($type:String!,$first:Int!,$after:String){metaobjects(type:$type,first:$first,after:$after){edges{node{id handle type fields{key value type reference{... on Metaobject{id handle type}}}}}pageInfo{hasNextPage endCursor}}}';
  var SCENE_QUERY = 'query GetScenes($type:String!,$first:Int!,$after:String){metaobjects(type:$type,first:$first,after:$after){edges{node{id handle fields{key value reference{... on MediaImage{id image{url altText}} ... on GenericFile{id url}}}}}pageInfo{hasNextPage endCursor}}}';
  function fetchAll(config, type, query) {
    var all = [], after = null, page = 0;
    function next() {
      page++;
      return gql(config, query, { type: type, first: Math.min(250, Math.max(50, number(config.storefront.page_size) || 250)), after: after }).then(function (d) {
        var conn = d && d.metaobjects;
        if (!conn) return all;
        (conn.edges || []).forEach(function (e) { all.push(e.node); });
        if (conn.pageInfo && conn.pageInfo.hasNextPage && page < (number(config.storefront.max_pages) || 10)) {
          after = conn.pageInfo.endCursor;
          return next();
        }
        return all;
      });
    }
    return next();
  }
  function parseConfig(root) {
    var el = root.querySelector('[data-pls2-config]');
    if (!el) throw new Error('Missing load planner configuration.');
    var config = JSON.parse(el.textContent || '{}');
    if (!config.storefront || !config.storefront.token || !config.shop_domain) throw new Error('Storefront API settings are missing. Check the section settings.');
    return config;
  }
  function start(root) {
    if (root.dataset.pls2Init === '1') return;
    root.dataset.pls2Init = '1';
    var config;
    try { config = parseConfig(root); } catch (e) { root.innerHTML += '<p class="pls2__empty">' + esc(e.message) + '</p>'; return; }

    var sceneTabs = root.querySelector('[data-pls2-scene-tabs]');
    var categoryTabs = root.querySelector('[data-pls2-category-tabs]');
    var deviceTrack = root.querySelector('[data-pls2-devices]');
    var hotspots = root.querySelector('[data-pls2-hotspots]');
    var totalEl = root.querySelector('[data-pls2-total]');
    var countEl = root.querySelector('[data-pls2-count]');
    var statusEl = root.querySelector('[data-pls2-status]');
    var clearBtn = root.querySelector('[data-pls2-clear]');
    var bar = root.querySelector('[data-pls2-capacity-bar]');
    var capacityCaption = root.querySelector('[data-pls2-capacity-caption]');
    var running = number(config.product.running_watt);
    var starting = number(config.product.starting_watt);
    var scenes = [], devices = [], allCategories = [], categories = [], activeScene = '', activeCategory = 'all';
    var selected = Object.create(null);

    function sceneName(s) { return val(s, 'name') || s.handle || 'Scenario'; }
    function sceneBannerUrl(s) {
      if (!s) return '';
      var map = Array.isArray(config.scene_banners) ? config.scene_banners : [];
      var sid = text(s.id || '').trim();
      var handle = text(s.handle || '').trim().toLowerCase();
      var name = text(val(s, 'name') || '').trim().toLowerCase();
      var entry = map.filter(function (item) {
        if (!item) return false;
        return (sid && text(item.id).trim() === sid) ||
          (handle && text(item.handle).trim().toLowerCase() === handle) ||
          (name && text(item.name).trim().toLowerCase() === name);
      })[0];

      if (entry && typeof entry.url === 'string' && entry.url.trim()) {
        return entry.url.trim();
      }

      // Fallback: try the Storefront API image/file reference.
      var f = field(s, 'benner');
      var r = f && f.reference;
      if (r && r.image && r.image.url) return r.image.url;
      if (r && r.url) return r.url;

      console.warn('[Load Planner v2] No Banner URL found for scene:', {
        id: sid, handle: handle, name: name, liquidMatch: !!entry,
        liquidUrl: entry ? entry.url : null, bennerField: f
      });
      return '';
    }
    function deviceSceneId(d) { var r = ref(d, 'category_level1'); return r ? r.id : ''; }
    function categoryId(d) { var r = ref(d, 'category_level2'); return r ? r.id : ''; }
    function categoryName(d) { var r = ref(d, 'category_level2'); if (!r) return 'Other'; var match = allCategories.filter(function (c) { return c.id === r.id; })[0]; return match ? match.name : (r.handle || 'Other').replace(/-/g, ' '); }
    function deviceName(d) { return val(d, 'device_name') || d.handle || 'Appliance'; }
    // Scene hotspot labels use device_name only; never use display_name or the metaobject handle.
    // Remove the first parenthetical note and anything after it for concise on-image labels.
    // The device cards below keep their existing full device_name unchanged.
    function hotspotTitle(d) {
      var full = val(d, 'device_name').trim();
      if (!full) return 'Appliance';
      return full.split(/[（(]/)[0].trim() || full;
    }
    function runW(d) { return Math.max(0, number(val(d, 'wattage')) * Math.max(1, number(val(d, 'default_quantity')) || 1)); }
    function startW(d) { return Math.max(runW(d), number(val(d, 'starting_wattage')) * Math.max(1, number(val(d, 'default_quantity')) || 1)); }
    function isPrimaryDisplay(d) {
      var raw = text(val(d, 'is_primary_display')).trim().toLowerCase();
      return raw === 'true' || raw === '1';
    }
    function pageCoordinates(d) {
      var raw = val(d, 'page_coordinates');
      if (!raw || !raw.trim()) return null;
      try {
        var coords = JSON.parse(raw);
        // Shopify JSON fields normally contain an object; also accept double-encoded JSON.
        if (typeof coords === 'string') coords = JSON.parse(coords);
        if (!coords || typeof coords !== 'object' || Array.isArray(coords)) return null;
        // Number(null) and Number('') are zero: do not treat missing values as valid coordinates.
        if (coords.x === undefined || coords.y === undefined || coords.x === null || coords.y === null ||
            String(coords.x).trim() === '' || String(coords.y).trim() === '') return null;
        var x = Number(coords.x), y = Number(coords.y);
        if (!isFinite(x) || !isFinite(y) || x < 0 || y < 0) return null;
        return { x: x, y: y };
      } catch (e) {
        return null;
      }
    }
    function currentDevices() { return devices.filter(function (d) { return deviceSceneId(d) === activeScene; }); }
    // Compatibility rule requested for this store:
    // device wattage must be strictly below the generator's starting_watt,
    // and device starting_wattage must be strictly below the generator's running_watt.
    function isCompatibleWithGenerator(d) {
      if (running <= 0 || starting <= 0) return false;
      return runW(d) < starting && startW(d) < running;
    }
    function compatibleCurrentDevices() {
      return currentDevices().filter(isCompatibleWithGenerator);
    }
    function currentHotspotDevices() {
      // Independent of the wattage-filtered carousel: show every primary device
      // that belongs to the current scene and has valid page_coordinates.
      // Incompatible hotspot cards remain visible but are not selectable.
      return currentDevices().filter(function (d) {
        return isPrimaryDisplay(d) && pageCoordinates(d) !== null;
      });
    }
    // V9: X/Y are the exact red-pin coordinates in stage pixels.
    // Never scale, clamp or move them. Only the surrounding label flips at stage edges.
    // Hotspot labels may overlap: no collision avoidance/reflow is performed.
    function layoutHotspotLabels() {
      var stage = root.querySelector('[data-pls2-stage]');
      if (!stage) return;
      var width = stage.clientWidth;
      var height = stage.clientHeight;
      if (!width || !height) return;

      var summary = stage.querySelector('.pls2__summary--overlay');
      var summaryTop = summary ? summary.offsetTop : height;
      var visibleBottom = Math.min(height, summaryTop) - 7;
      var padding = 7;
      var lineGap = 23;

      hotspots.querySelectorAll('[data-pls2-hotspot-anchor]').forEach(function (anchor) {
        var card = anchor.querySelector('.pls2__hotspot');
        var connector = anchor.querySelector('.pls2__hotspot-connector');
        if (!card || !connector) return;
        // The absolute element is measured at its natural size; SVG/pin do not affect it.
        var w = card.offsetWidth;
        var h = card.offsetHeight;
        var x = Number(anchor.dataset.x);
        var y = Number(anchor.dataset.y);
        if (!isFinite(x) || !isFinite(y)) return;

        // Default matches the original label-above-pin composition (pin near left).
        // Only choose a different orientation when default overflows a scene edge.
        var candidates = [
          { name: 'top', left: -24, top: -h - lineGap },
          { name: 'bottom', left: -24, top: lineGap },
          { name: 'left', left: -w - lineGap, top: -h / 2 },
          { name: 'right', left: lineGap, top: -h / 2 },
          { name: 'bottom-left', left: -w - lineGap, top: lineGap },
          { name: 'bottom-right', left: lineGap, top: lineGap },
          { name: 'top-left', left: -w - lineGap, top: -h - lineGap },
          { name: 'top-right', left: lineGap, top: -h - lineGap }
        ];
        function overflow(c) {
          var l = x + c.left;
          var t = y + c.top;
          var r = l + w;
          var b = t + h;
          return Math.max(0, padding - l) +
            Math.max(0, r - (width - padding)) +
            Math.max(0, padding - t) +
            Math.max(0, b - visibleBottom);
        }
        var choice = candidates[0];
        // When normal orientation fits, keep it. Otherwise find an edge-safe orientation.
        // No comparison with other labels: overlaps remain allowed.
        if (overflow(choice) > 0) {
          var bestOverflow = Infinity;
          candidates.forEach(function (candidate) {
            var amount = overflow(candidate);
            if (amount < bestOverflow) {
              bestOverflow = amount;
              choice = candidate;
            }
          });
        }

        card.style.left = Math.round(choice.left) + 'px';
        card.style.top = Math.round(choice.top) + 'px';
        anchor.dataset.placement = choice.name;

        // Connect red pin (0,0) to the nearest point on the label rectangle.
        // This works regardless of whether the label is above/below/left/right.
        var cx = Math.max(choice.left, Math.min(0, choice.left + w));
        var cy = Math.max(choice.top, Math.min(0, choice.top + h));
        var dist = Math.sqrt(cx * cx + cy * cy);
        var angle = Math.atan2(cy, cx) * 180 / Math.PI;
        connector.style.width = Math.round(dist * 100) / 100 + 'px';
        connector.style.transform = 'rotate(' + angle + 'deg)';
      });
    }
    function currentCategories() {
      var seen = Object.create(null), list = [];
      compatibleCurrentDevices().forEach(function (d) {
        var id = categoryId(d) || 'other';
        if (!seen[id]) { seen[id] = true; list.push({ id: id, name: categoryName(d) }); }
      });
      return list;
    }
    function selectedItems() { return devices.filter(function (d) { return !!selected[d.id]; }); }
    function sums() {
      var chosen = selectedItems();
      return {
        count: chosen.length,
        run: chosen.reduce(function (s, d) { return s + runW(d); }, 0),
        start: chosen.reduce(function (s, d) { return s + startW(d); }, 0)
      };
    }
    function renderScenes() {
      sceneTabs.innerHTML = scenes.map(function (s, i) {
        var name = sceneName(s), active = s.id === activeScene;
        var nameLower = name.toLowerCase();
        var sceneIcon = nameLower.indexOf('home') !== -1 ? '🏠' : nameLower.indexOf('camp') !== -1 || nameLower.indexOf('rv') !== -1 ? '🚐' : nameLower.indexOf('food') !== -1 || nameLower.indexOf('kitchen') !== -1 ? '🍔' : nameLower.indexOf('work') !== -1 || nameLower.indexOf('tool') !== -1 ? '🛠️' : '🌲';
        return '<button class="pls2__scene-tab' + (active ? ' is-active' : '') + '" type="button" role="tab" aria-selected="' + active + '" data-pls2-scene="' + esc(s.id) + '"><span class="pls2__scene-tab-icon">' + sceneIcon + '</span>' + esc(name) + '</button>';
      }).join('');
      var s = scenes.filter(function (x) { return x.id === activeScene; })[0];
      root.querySelector('[data-pls2-scene-title]').textContent = s ? sceneName(s) : 'Power Scenario';
      root.querySelector('[data-pls2-scene-description]').textContent = 'Tap a device hotspot or use the appliance cards below to add it to your load estimate.';
      var bannerImg = root.querySelector('[data-pls2-scene-banner]');
      if (bannerImg) {
        var bannerUrl = s ? sceneBannerUrl(s) : '';
        bannerImg.classList.remove('is-loaded');
        bannerImg.onerror = function () {
          bannerImg.removeAttribute('src');
          bannerImg.classList.remove('is-loaded');
          console.warn('[Load Planner v2] Banner image failed to load for scene:', s ? sceneName(s) : 'unknown', bannerUrl);
        };
        bannerImg.onload = function () {
          bannerImg.classList.add('is-loaded');
        };
        if (bannerUrl) {
          if (bannerImg.getAttribute('src') !== bannerUrl) bannerImg.src = bannerUrl;
          else if (bannerImg.complete && bannerImg.naturalWidth > 0) bannerImg.classList.add('is-loaded');
        } else {
          bannerImg.removeAttribute('src');
          console.warn('[Load Planner v2] Banner is configured in Liquid but no usable URL was resolved for the active scene:', s ? sceneName(s) : 'unknown');
        }
      }
    }
    function renderCategories() {
      categories = currentCategories();
      if (activeCategory !== 'all' && !categories.some(function (c) { return c.id === activeCategory; })) activeCategory = 'all';
      categoryTabs.innerHTML = '<button type="button" class="pls2__category-tab' + (activeCategory === 'all' ? ' is-active' : '') + '" data-pls2-category="all">All devices</button>' +
        categories.map(function (c) { return '<button type="button" class="pls2__category-tab' + (activeCategory === c.id ? ' is-active' : '') + '" data-pls2-category="' + esc(c.id) + '">' + esc(c.name) + '</button>'; }).join('');
    }
    function visibleDevices() {
      return compatibleCurrentDevices().filter(function (d) { return activeCategory === 'all' || (categoryId(d) || 'other') === activeCategory; });
    }
    function renderDevices() {
      var list = visibleDevices();
      if (!list.length) {
        var hasSceneDevices = currentDevices().length > 0;
        var message = hasSceneDevices
          ? 'No devices in this scenario meet this generator’s wattage limits.'
          : 'No devices are linked to this scenario yet.';
        deviceTrack.innerHTML = '<p class="pls2__empty">' + esc(message) + '</p>';
        return;
      }
      deviceTrack.innerHTML = list.map(function (d) {
        var on = !!selected[d.id], watt = Math.round(runW(d));
        return '<button type="button" class="pls2__device-card' + (on ? ' is-selected' : '') + '" data-pls2-device="' + esc(d.id) + '" aria-pressed="' + on + '">' +
          '<span class="pls2__device-card-top"><span class="pls2__device-icon">' + icon(deviceName(d)) + '</span><span class="pls2__device-check">✓</span></span>' +
          '<span class="pls2__device-name">' + esc(deviceName(d)) + '</span>' +
          '<span class="pls2__device-bottom"><strong class="pls2__device-watt">' + watt + 'W</strong><span class="pls2__device-unit">running</span></span></button>';
      }).join('');
    }
    function renderHotspots() {
      var list = currentHotspotDevices();
      if (!list.length) { hotspots.innerHTML = ''; return; }
      hotspots.innerHTML = list.map(function (d) {
        var pos = pageCoordinates(d);
        var on = !!selected[d.id];
        var available = isCompatibleWithGenerator(d);
        var fullName = hotspotTitle(d);
        var tooltip = available ? fullName : fullName + ': exceeds this generator\'s device wattage criteria';
        return '<div class="pls2__hotspot-anchor" data-pls2-hotspot-anchor data-x="' + pos.x + '" data-y="' + pos.y +
          '" style="left:' + pos.x + 'px;top:' + pos.y + 'px">' +
          '<span class="pls2__hotspot-connector" aria-hidden="true"></span>' +
          '<span class="pls2__hotspot-pin" aria-hidden="true"></span>' +
          '<button type="button" class="pls2__hotspot' + (on ? ' is-selected' : '') + (!available ? ' is-unavailable' : '') +
          '" data-pls2-device="' + esc(d.id) +
          '" aria-pressed="' + on + '" aria-label="' + esc(fullName + ', ' + Math.round(runW(d)) + ' watts') +
          '" title="' + esc(tooltip) + '"' + (available ? '' : ' disabled aria-disabled="true"') + '>' +
          '<span class="pls2__hotspot-icon">' + icon(deviceName(d)) + '</span>' +
          '<span class="pls2__hotspot-text"><span class="pls2__hotspot-name">' + esc(hotspotTitle(d)) +
          '</span><span class="pls2__hotspot-watt">' + Math.round(runW(d)) +
          'W</span></span></button></div>';
      }).join('');
      layoutHotspotLabels();
    }
    function renderSummary() {
      var s = sums(), ratio = running > 0 ? Math.min(100, s.run / running * 100) : 0;
      totalEl.textContent = Math.round(s.run).toLocaleString() + 'W';
      countEl.textContent = s.count + (s.count === 1 ? ' device selected' : ' devices selected');
      bar.style.width = ratio + '%';
      capacityCaption.textContent = running > 0 ? Math.round(ratio) + '% of rated running capacity used in this example.' : 'Add a running-wattage product metafield to enable capacity comparison.';
      if (running > 0 && s.run > running) {
        statusEl.classList.add('is-warning');
        statusEl.querySelector('strong').textContent = 'Selected load exceeds running watts';
        statusEl.querySelector('p').textContent = 'Your selected running load is above this generator’s listed running capacity. Remove devices or check your requirements.';
      } else if (starting > 0 && s.start > starting) {
        statusEl.classList.add('is-warning');
        statusEl.querySelector('strong').textContent = 'Check startup surge';
        statusEl.querySelector('p').textContent = 'The estimated combined startup demand may exceed the listed starting watts. Actual startup overlap matters.';
      } else {
        statusEl.classList.remove('is-warning');
        statusEl.querySelector('strong').textContent = s.count ? 'Within the listed running-watt range' : 'Ready to calculate';
        statusEl.querySelector('p').textContent = s.count ? 'Illustrative estimate only. Verify actual appliance labels and startup requirements.' : 'Select devices to compare your estimated load.';
      }
    }
    function renderAll() { renderScenes(); renderCategories(); renderDevices(); renderHotspots(); renderSummary(); }
    function toggle(id) {
      var device = devices.filter(function (d) { return d.id === id; })[0];
      // Prevent hidden / incompatible devices from being selected via stale markup or hotspots.
      if (!device || !isCompatibleWithGenerator(device)) return;
      selected[id] = !selected[id];
      if (!selected[id]) delete selected[id];
      renderDevices(); renderHotspots(); renderSummary();
    }
    sceneTabs.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pls2-scene]'); if (!btn) return;
      activeScene = btn.getAttribute('data-pls2-scene'); activeCategory = 'all'; selected = Object.create(null); renderAll();
    });
    categoryTabs.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pls2-category]'); if (!btn) return;
      activeCategory = btn.getAttribute('data-pls2-category'); renderCategories(); renderDevices();
    });
    deviceTrack.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pls2-device]'); if (btn) toggle(btn.getAttribute('data-pls2-device'));
    });
    hotspots.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pls2-device]'); if (btn) toggle(btn.getAttribute('data-pls2-device'));
    });
    clearBtn.addEventListener('click', function () { selected = Object.create(null); renderAll(); });
    var sceneStage = root.querySelector('[data-pls2-stage]');
    if (sceneStage && typeof ResizeObserver !== 'undefined') {
      var sceneWidth = 0, sceneHeight = 0;
      var hotspotObserver = new ResizeObserver(function () {
        var w = sceneStage.clientWidth, h = sceneStage.clientHeight;
        if (w !== sceneWidth || h !== sceneHeight) {
          sceneWidth = w; sceneHeight = h;
          if (activeScene && devices.length) layoutHotspotLabels();
        }
      });
      hotspotObserver.observe(sceneStage);
    }

    Promise.all([
      fetchAll(config, config.metaobject_types.level1, SCENE_QUERY),
      fetchAll(config, config.metaobject_types.level2, SCENE_QUERY),
      fetchAll(config, config.metaobject_types.option, DEVICE_QUERY)
    ]).then(function (result) {
      var fetchedScenes = result[0];
      var order = Array.isArray(config.scene_order) ? config.scene_order : [];
      console.info('[Load Planner V3] Product scene order:', {
        product: config.product_debug,
        configured: config.scene_order_configured,
        count: order.length,
        references: order.map(function (entry) { return { id: entry.id, handle: entry.handle }; })
      });
      if (order.length) {
        // An explicit list controls BOTH which scenes appear and their order.
        // Match by handle (preferred) or numeric/GID ID. Never add unselected scenes.
        function idKey(v) { return text(v).split('/').pop(); }
        var used = Object.create(null);
        scenes = order.map(function (entry) {
          var handle = text(entry.handle).trim().toLowerCase();
          var id = idKey(entry.id);
          var match = fetchedScenes.find(function (s) {
            return (handle && text(s.handle).trim().toLowerCase() === handle) || (id && idKey(s.id) === id);
          });
          if (match && !used[match.id]) { used[match.id] = true; return match; }
          return null;
        }).filter(Boolean);
        if (scenes.length !== order.length) {
          console.warn('[Load Planner v2] Some product load_scene_order references were not returned by Storefront API:', order);
        }
      } else if (config.scene_order_configured) {
        // The product metafield exists but Liquid returned zero references.
        // Do NOT silently render all five scenes: make the configuration failure visible.
        scenes = [];
        console.error('[Load Planner V3] custom.load_scene_order is set, but no references were resolved by Liquid. Verify the metafield reference type and that this is the correct product.');
      } else {
        // Only products without a scene-order metafield use global Sort fallback.
        var sorts = Array.isArray(config.scene_sort) ? config.scene_sort : [];
        function globalSort(scene) {
          var item = sorts.find(function (e) { return text(e.handle).toLowerCase() === text(scene.handle).toLowerCase(); });
          return item && isFinite(Number(item.sort)) ? Number(item.sort) : 9999;
        }
        scenes = fetchedScenes.slice().sort(function (a, b) { return globalSort(a) - globalSort(b); });
      }
      allCategories = result[1].map(function (n) { return { id: n.id, name: val(n, 'name') || n.handle }; });
      devices = result[2].filter(function (d) { return !!ref(d, 'category_level1'); });
      if (!scenes.length) throw new Error('No matching scenes found for this product. Confirm custom.load_scene_order is populated on this exact product, has category_level1 references, and the storefront can access them.');
      if (!devices.length) throw new Error('No device options were found. Check the device_power_option metaobject type and its category_level1 references.');
      activeScene = scenes[0].id;
      renderAll();
    }).catch(function (e) {
      console.error('[Load Planner v2]', e);
      sceneTabs.innerHTML = '';
      deviceTrack.innerHTML = '<p class="pls2__empty">Could not load the device catalog. ' + esc(e.message) + '</p>';
      root.querySelector('[data-pls2-scene-title]').textContent = 'Load planner unavailable';
      root.querySelector('[data-pls2-scene-description]').textContent = 'Check the Storefront API token, API version, and metaobject permissions.';
    });
  }
  function boot(scope) { (scope || document).querySelectorAll(ROOT).forEach(start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target || document); });
})();